<template>
    <fieldset :disabled="isDisabled">

        <section class="row">

            <div class="col-sm-6 my-2">
                <label class="col-form-label">Province selection</label>
                <select class="form-control border border-dark" size="8" v-model="provinceArray" :multiple="canMultiple">
                    <option v-for="item in provinces" :value="item">
                        <span class="badge badge-secondary">{{ item.code }}</span>
                        {{ item.name }}
                    </option>
                </select>
                <div class="btn btn-block btn-primary border border-dark my-2" @click="commonAddSelected(provinceArray)">Add selected provinces</div>
            </div>

            <div class="col-sm-6 my-2" v-show="provinceIsSelected">
                <label class="col-form-label">District selection</label>
                <select class="form-control border border-dark" size="8" v-model="districtArray" :multiple="canMultiple">
                    <option v-for="item in districts" :value="item">
                        <span class="badge badge-secondary">{{ item.code }}</span>
                        {{ item.name }}
                    </option>
                </select>
                <div class="btn btn-block btn-primary border border-dark my-2" @click="commonAddSelected(districtArray);">Add selected districts</div>
            </div>

        </section>

        <section class="row">

            <div class="col-sm-6 my-2" v-show="districtIsSelected">
                <label class="col-form-label">Sector selection</label>
                <select class="form-control border border-dark" size="8" v-model="sectorArray" :multiple="canMultiple">
                    <option v-for="item in sectors" :value="item">
                        <span class="badge badge-secondary">{{ item.code }}</span>
                        {{ item.name }}
                    </option>
                </select>
                <div class="btn btn-block btn-primary border border-dark my-2" @click="commonAddSelected(sectorArray);">Add selected sectors</div>
            </div>

            <div class="col-sm-6 my-2" v-show="sectorIsSelected">
                <label class="col-form-label">Cell selection</label>
                <select class="form-control border border-dark" size="8" v-model="cellArray" :multiple="canMultiple">
                    <option v-for="item in cells" :value="item">
                        <Span class="badge badge-secondary">{{ item.code }}</span>
                        {{ item.name }}
                    </option>
                </select>
                <div class="btn btn-block btn-primary border border-dark my-2" @click="commonAddSelected(cellArray);">Add selected cells</div>
            </div>

        </section>

        <section class="row">

            <div class="col-sm-6 my-2" v-show="cellIsSelected">
                <label class="col-form-label">Village selection</label>
                <select class="form-control border border-dark" size="8" v-model="villageArray" :multiple="canMultiple">
                    <option v-for="item in villages" :value="item">
                        <span class="badge badge-secondary">{{ item.code }}</span>
                        {{ item.name }}
                    </option>
                </select>
                <div class="btn btn-block btn-primary border border-dark my-2" @click="commonAddSelected(villageArray);">Add selected villages</div>
            </div>

        </section>

        <section class="alert alert-info" v-if="canMultiple">
            <p>Choosen administrative regions</p>
            <div class="row" v-for="(item, index) of selectedArray">

                <div class="col-sm-2"> <span class="badge badge-secondary">{{ item.code }}</span> </div>

                <div class="col-sm-8"> <strong>{{ item.name }}</strong> </div>

                <div class="col-sm-2">
                    <div class="badge badge-pill badge-light" @click="removeAtIndex(index)"> <span class="fa fa-times text-danger"></span> </div>
                </div>

            </div>
            <div class="btn btn-block btn-danger border border-dark my-2" @click="clearSelectedItems()">Clear all selected administrative units</div>
        </section>

    </fieldset>
</template>

<script>
export default{
    props : {

        provinces : {
            type : Array,
            required : true
        },

        isDisabled : {
            type : Boolean,
            default : false
        },

        canMultiple : {
            type : Boolean,
            default : true
        }

    },

    data(){
        return {
            // id(s) containers
            provinceArray: [],
            districtArray : [],
            sectorArray : [],
            cellArray : [],
            villageArray : [],
            schoolArray : [],
            // AJAX result containers
            districts : [],
            sectors : [],
            cells : [],
            villages : [],
            schools : [],

            selectedArray : [],
        };
    },

    computed : {

        provinceIsSelected(){
            return ((this.canMultiple) ? (this.provinceArray.length > 0) : (this.provinceArray.id != null));
        },

        districtIsSelected(){
            return ((this.canMultiple) ? (this.districtArray.length > 0) : (this.districtArray.id != null));
        },

        sectorIsSelected(){
            return ((this.canMultiple) ? (this.sectorArray.length > 0) : (this.sectorArray.id != null));
        },

        cellIsSelected(){
            return ((this.canMultiple) ? (this.cellArray.length > 0) : (this.cellArray.id != null));
        },

    },

    watch : {

        provinceArray(){
            if (this.checkChanges(this.provinceArray)) return;

            this.schoolArray = [];
            this.villageArray = [];
            this.cellArray = [];
            this.sectorArray = [];
            this.districtArray = [];

            this.districts = this.commonAjax(this.provinceArray, "districts");
        },

		districtArray(){
            if (this.checkChanges(this.districtArray)) return;

            this.schoolArray = [];
            this.villageArray = [];
            this.cellArray = [];
            this.sectorArray = [];

            this.sectors = this.commonAjax(this.districtArray, "sectors");
        },

        sectorArray(){
            if (this.checkChanges(this.sectorArray)) return;

            this.schoolArray = [];
            this.villageArray = [];
            this.cellArray = [];

            this.cells = this.commonAjax(this.sectorArray, "cells");
        },

        cellArray(){
            if (this.checkChanges(this.cellArray)) return;

            this.schoolArray = [];
            this.villageArray = [];

            this.villages = this.commonAjax(this.cellArray, "villages");
        },

        villageArray(){
            if (this.checkChanges(this.villageArray)) return;
        }

    },

    methods : {

        commonAddSelected(anyArray){
            if (this.canMultiple){
                let seekIndex;
                for (let item of anyArray){
                    seekIndex = this.selectedArray.map((item) => { return item.code; }).indexOf(item.code);

                    if (seekIndex < 0) this.selectedArray.push(item);
                }

                this.selectedArray.sort((item1, item2) => { return item1.code > item2.code; });
            } else { this.selectedArray = anyArray; }

            this.reportSelected();
        },

        checkChanges(anyArray){
            if (this.canMultiple){
                if (anyArray.length === 0) return true;
            } else {
                if (anyArray.id == null) return true;
            }

            return false;
        },

        commonAjax(anyArray, nextLevel){
            let responseArray = [];
            let url = "";

            // process url
            if (this.canMultiple){
                url = `${APP_URL}/administrative-units/` + nextLevel + "/dataset/" + anyArray.map((item) => { return item.id; });
            } else {
                url = `${APP_URL}/administrative-units/` + nextLevel + "/dataset/" + anyArray.id;
            }

            // make substitute temp array of administrative units
            window.axios.get(url)
                .then((response) => {
                    for (let item of response.data) responseArray.push(item);
                })
                .catch((error) => { window.console.error(error); });

            return responseArray;
        },

        reportSelected(){
            this.$emit("selected", this.selectedArray);
        },

        clearSelectedItems(){
            this.selectedArray.splice(0);
            this.reportSelected();
        },

        removeAtIndex(index){
            this.selectedArray.splice(index, 1);
        }

    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/data-set/AdministrativeUnitsFilterAndSelect.vue